/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertAnthropicInferenceConfigRequestBody,
  UpsertAnthropicInferenceConfigRequestBody$Outbound,
  UpsertAnthropicInferenceConfigRequestBody$outboundSchema,
} from "../components/upsertanthropicinferenceconfigrequestbody.js";

export type UpsertAnthropicInferenceConfigSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpsertAnthropicInferenceConfigRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  upsertAnthropicInferenceConfigRequestBody:
    UpsertAnthropicInferenceConfigRequestBody;
};

/** @internal */
export type UpsertAnthropicInferenceConfigSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpsertAnthropicInferenceConfigSecurity$outboundSchema:
  z.ZodMiniType<
    UpsertAnthropicInferenceConfigSecurity$Outbound,
    UpsertAnthropicInferenceConfigSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function upsertAnthropicInferenceConfigSecurityToJSON(
  upsertAnthropicInferenceConfigSecurity:
    UpsertAnthropicInferenceConfigSecurity,
): string {
  return JSON.stringify(
    UpsertAnthropicInferenceConfigSecurity$outboundSchema.parse(
      upsertAnthropicInferenceConfigSecurity,
    ),
  );
}

/** @internal */
export type UpsertAnthropicInferenceConfigRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  UpsertAnthropicInferenceConfigRequestBody:
    UpsertAnthropicInferenceConfigRequestBody$Outbound;
};

/** @internal */
export const UpsertAnthropicInferenceConfigRequest$outboundSchema:
  z.ZodMiniType<
    UpsertAnthropicInferenceConfigRequest$Outbound,
    UpsertAnthropicInferenceConfigRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      upsertAnthropicInferenceConfigRequestBody:
        UpsertAnthropicInferenceConfigRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        upsertAnthropicInferenceConfigRequestBody:
          "UpsertAnthropicInferenceConfigRequestBody",
      });
    }),
  );

export function upsertAnthropicInferenceConfigRequestToJSON(
  upsertAnthropicInferenceConfigRequest: UpsertAnthropicInferenceConfigRequest,
): string {
  return JSON.stringify(
    UpsertAnthropicInferenceConfigRequest$outboundSchema.parse(
      upsertAnthropicInferenceConfigRequest,
    ),
  );
}
